import { twMerge } from 'tailwind-merge'

export const HORIZONTAL_PICKER_LITE_DESKTOP_HEIGHT = 60
export const FILTER_GROUPS_DESKTOP_HEIGHT = 42

// Common popover styles for external filters
export const POPOVER_HEADER_STYLES =
  'border-shades-200 text-shades-600 border-b px-6 py-[17px] text-sm font-bold uppercase tracking-widest'
export const POPOVER_BODY_STYLES = `bg-shades-25 p-[24px]`
export const POPOVER_CTA_STYLES = 'w-full cursor-pointer py-[9px] pl-[16px] pr-8 truncate relative'
export const POPOVER_FILTER_CONTAINER_STYLE = { clipPath: `inset(0px -1px -500px 0px)` }

export type CommonFilterProps = {
  containerClasses?: string
  handleFilterToggle?: (event: React.MouseEvent<HTMLElement>, i: number) => void
  filterIndex?: number
  anchorEl?: HTMLElement
  isOpen: boolean
  onClose: () => void
}

// Placeholder component for filters
type FilterContainerWrapperPlaceholderProps = {
  className?: string
} & React.HTMLAttributes<HTMLDivElement>
export const FilterContainerWrapperPlaceholder = ({ className }: FilterContainerWrapperPlaceholderProps) => (
  <div className={twMerge('h-full w-full border border-shades-200 bg-shades-200', className)} />
)

// Wrapper for components to be able to utilize no-ssr views & placeholders
export type FilterContainerWrapperProps = React.HTMLAttributes<HTMLDivElement> & { noDropShadowFix?: boolean }
export const FilterContainerWrapper = ({ className, noDropShadowFix, children }: FilterContainerWrapperProps) => (
  <div className={className} style={noDropShadowFix ? {} : POPOVER_FILTER_CONTAINER_STYLE}>
    {children}
  </div>
)
